<template>
  <div id="video"></div>
</template>

<script>
export default {
  props: ["url"],
  data: () => {
    return {
      currentTraceTime: 0
    };
  },
  methods: {
    async renderJwplayer(url) {
      console.log(url)
      const mockUrl = [
        {
          image: '',
          file:
            'http://cdn-vod.nerdof.com/hls/60545365f243c114b2b9d02d.mp4/index.m3u8',
        },
        {
          image: '',
          file:
            'http://cdn-vod.nerdof.com/hls/60545365f243c114b2b9d02d_1.mp4/index.m3u8',
        },
      ];
      await window.jwplayer("video").setup({ 
        // sources: url,
        // playlist: url,
        sources: [{file:url}],
        autostart: false,
        width: "100%"
      });
    }
  },
  mounted() {
    this.renderJwplayer(this.url);
  },
  watch: {
    url(newUrl) {
      this.renderJwplayer(newUrl);
    }
  }
};
</script>